module.exports = __webpack_public_path__ + "static/media/tn.2196b3ef.JPG";